<h6 id="table_documentoOperaList">Elenco documenti progetto</h6>
<div style="transform: rotateX(180deg);" class="table-responsive mb-3">
    <table style="transform: rotateX(180deg);" class="table table-striped table-sm" aria-describedby="table_documentoOperaList">
        <thead class="thead-light">
            <tr>
                <th scope="col">ID</th>
                <th scope="col">Nome documento</th>
                <th scope="col">Classe documento</th>
                <th scope="col">Didascalia</th>
                <th scope="col">Data inserimento</th>
                <th scope="col">Visibilità</th>
                <th scope="col"></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of items">
                <td>{{ item.idDocumento }}</td>
                <td>{{ item.nomeDocumento }}</td>
                <td>{{ item.idClasseDocumento | anagraficaClasseDocumento: (datalist.classeDocumento || []) }}</td>
                <td>{{ item.didascalia }}</td>
                <td>{{ item.createdAt | date: 'dd/MM/yyyy' }}</td>
                <td>{{ item.docPublic === 0 ? 'Privato' : 'Pubblico' }}</td>
                <td class="actions">
                    <button aria-label="scarica il documento" type="button" (click)="documentoProgettoDownload(item)" class="btn btn-xs btn-link" container="body" ngbTooltip="Scarica il documento">
                        <app-toolkit-bl-icon icon="download" cssClass="icon icon-sm icon-secondary"></app-toolkit-bl-icon>
                    </button>
                    <button aria-label="modifica" *ngIf="canEdit" type="button" (click)="editItem(item)" class="btn btn-xs btn-link" container="body" ngbTooltip="Modifica">
                        <app-toolkit-bl-icon icon="pencil" cssClass="icon icon-sm icon-secondary"></app-toolkit-bl-icon>
                    </button>
                    <button aria-label="elimina" *ngIf="canEdit" class="btn btn-xs btn-link" (click)="deleteItem(item.idDocumento)" container="body" ngbTooltip="Elimina">
                        <app-toolkit-bl-icon icon="close" cssClass="icon icon-sm icon-danger"></app-toolkit-bl-icon>
                    </button>
                </td>
            </tr>
            <tr *ngIf="!items.length">
                <td colspan="7"><p class="mb-0 text-center">Nessun risultato trovato.</p></td>
            </tr>
        </tbody>
    </table>
</div>
<div *ngIf="canEdit" class="button-actions">
    <button type="button" class="btn btn-outline-primary" (click)="addItem()">
        <app-toolkit-bl-icon icon="plus" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
        Aggiungi
    </button>
</div>